import styled from '@emotion/styled'

export const ImageWrapper = styled.div`
  width: 50%;
  max-height: 32px;
  padding-left: ${({ theme }) => theme.spacing(0.5)};
  text-align: end;
`
